export class MouAcceptance {
    MOU_DOCUMENTS_ID?: number;
    PARTIES_ID?: number;
    SIGNATURE?: string;
}
